/* Pre-Access-Anmeldung der Passwortseite — direkt an Klaviyo, ohne
   Seitenwechsel.

   Vorher war das hier Klaviyos altes Listen-Formular: ein GET auf
   manage.kmail-lists.com mit target="_blank", das Klaviyos gehostete
   Anmeldeseite in einem neuen Tab aufgemacht hat. Jetzt geht die Adresse
   per fetch an den oeffentlichen Client-Endpunkt, und die Rueckmeldung
   erscheint auf der Seite.

   Wichtig fuer die Texte: Klaviyo antwortet mit 202 und leerem Body. Die
   Antwort sagt NICHT, ob eine Double-Opt-in-Mail rausging oder ob die
   Adresse schon auf der Liste stand — das ist Absicht, sonst koennte
   jeder ueber das Formular abfragen, wer eingetragen ist. Deshalb gibt es
   nur eine Erfolgsmeldung, und die muss beide Faelle abdecken. Welcher
   Text erscheint, steuert data-optin (double|single) aus den
   Section-Einstellungen.

   Ob Klaviyo tatsaechlich doppelt bestaetigen laesst, haengt allein an
   den Opt-in-Einstellungen der Liste in Klaviyo — nicht an diesem Code. */
(() => {
  const ENDPOINT = 'https://a.klaviyo.com/client/subscriptions';
  const REVISION = '2026-07-15';
  const LOG_PREFIX = '[Herlamora Pre-Access]';

  const setState = (form, state, message) => {
    const box = form.querySelector('[data-signup-status]');
    form.dataset.state = state;
    if (!box) return;
    box.textContent = message || '';
    box.hidden = !message;
    box.classList.toggle('hlp__signup-status--error', state === 'error');
    box.classList.toggle('hlp__signup-status--success', state === 'success');
  };

  /* Rueckfall auf das alte Verhalten (action/method/target stehen weiter
     im Markup): oeffnet Klaviyos gehostete Seite in einem neuen Tab.
     Greift nur, wenn der Request gar nicht durchkommt — besser ein
     Tabwechsel als eine verlorene Anmeldung. */
  const nativeSubmit = (form, reason) => {
    console.warn(LOG_PREFIX, 'Rueckfall auf Klaviyos gehostetes Formular:', reason);
    setState(form, 'idle', '');
    form.dataset.fallback = 'true';
    HTMLFormElement.prototype.submit.call(form);
  };

  const submit = async (form) => {
    const input = form.querySelector('input[type="email"]');
    const button = form.querySelector('button[type="submit"]');
    const company = form.dataset.company;
    const list = form.dataset.list;

    if (!input || !input.value) return;

    /* Ohne Konfiguration waere der Request sinnlos — dann lieber eine
       ehrliche Fehlermeldung als ein falsches "hat geklappt". */
    if (!company || !list) {
      console.warn(LOG_PREFIX, 'Konto- oder Listen-ID fehlt in den Section-Einstellungen.');
      setState(form, 'error', form.dataset.msgError);
      return;
    }

    setState(form, 'loading', form.dataset.msgLoading);
    if (button) button.disabled = true;

    const payload = {
      data: {
        type: 'subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: input.value.trim(),
                subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } },
              },
            },
          },
        },
        relationships: { list: { data: { type: 'list', id: list } } },
      },
    };

    try {
      const response = await fetch(`${ENDPOINT}?company_id=${encodeURIComponent(company)}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/vnd.api+json',
          revision: REVISION,
        },
        body: JSON.stringify(payload),
      });

      if (response.ok) {
        /* 202: angenommen. Mehr verraet Klaviyo nicht, siehe oben. */
        const isDouble = form.dataset.optin !== 'single';
        setState(form, 'success', isDouble ? form.dataset.msgDouble : form.dataset.msgSingle);
        form.reset();
      } else if (response.status === 400 || response.status === 422) {
        /* An der Eingabe liegt es: Adresse pruefen lassen. */
        setState(form, 'error', form.dataset.msgError);
      } else {
        /* 403 & Co. heisst Konfiguration, nicht Nutzerfehler — etwa wenn
           die Domain nicht auf Klaviyos Allowlist fuer den Public Key
           steht. Dann lieber klassisch abschicken als die Anmeldung
           verlieren. */
        nativeSubmit(form, `HTTP ${response.status}`);
      }
    } catch (error) {
      /* Netzwerk weg oder Request geblockt: ebenfalls klassisch. */
      nativeSubmit(form, error && error.message ? error.message : 'fetch fehlgeschlagen');
    } finally {
      if (button) button.disabled = false;
    }
  };

  const init = () => {
    document.querySelectorAll('form[data-klaviyo-form]').forEach((form) => {
      if (form.dataset.bound) return;
      form.dataset.bound = 'true';
      form.addEventListener('submit', (event) => {
        event.preventDefault();
        submit(form);
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
